import { render, staticRenderFns } from "./coopMembers.vue?vue&type=template&id=05ea2136&scoped=true&"
import script from "./coopMembers.vue?vue&type=script&lang=js&"
export * from "./coopMembers.vue?vue&type=script&lang=js&"
import style0 from "./coopMembers.vue?vue&type=style&index=0&id=05ea2136&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea2136",
  null
  
)

export default component.exports